/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ApiResult,
    ConnectorPricingAssignmentRequest,
    ConnectorPricingScheduleListResponse,
    DevicePricingScheduleGroupDto,
    PricingScheduleDto,
    PricingSchedulesResponse,
} from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    ConnectorPricingAssignmentRequestFromJSON,
    ConnectorPricingAssignmentRequestToJSON,
    ConnectorPricingScheduleListResponseFromJSON,
    ConnectorPricingScheduleListResponseToJSON,
    DevicePricingScheduleGroupDtoFromJSON,
    DevicePricingScheduleGroupDtoToJSON,
    PricingScheduleDtoFromJSON,
    PricingScheduleDtoToJSON,
    PricingSchedulesResponseFromJSON,
    PricingSchedulesResponseToJSON,
} from "../models/index";

export interface AssignConnectorPricingScheduleRequest {
    body?: ConnectorPricingAssignmentRequest;
}

export interface ConnectorPricingScheduleAddRequest {
    body?: PricingScheduleDto;
}

export interface DeviceConnectorPricingScheduleRequest {
    deviceIdentity: string;
    connectorIndex?: number;
}

export interface GetDevicesByPricingScheduleGroupIdRequest {
    pricingScheduleGroupId: string;
}

export interface PricingScheduleListByPricingScheduleGroupIdRequest {
    pricingScheduleGroupId: string;
}

/**
 *
 */
export class DeviceConnectorPricingHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Assign pricing schedule group to devices/connectors
     */
    async assignConnectorPricingScheduleRaw(
        requestParameters: AssignConnectorPricingScheduleRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/connector-pricing-schedules/assign`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: ConnectorPricingAssignmentRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Assign pricing schedule group to devices/connectors
     */
    async assignConnectorPricingSchedule(
        requestParameters: AssignConnectorPricingScheduleRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.assignConnectorPricingScheduleRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Add a Connector Pricing Schedule to an existing or new schedule group (set PricingScheduleGroupId = 0 for a new group).
     */
    async connectorPricingScheduleAddRaw(
        requestParameters: ConnectorPricingScheduleAddRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/connector-pricing-schedules/add-schedule`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: PricingScheduleDtoToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Add a Connector Pricing Schedule to an existing or new schedule group (set PricingScheduleGroupId = 0 for a new group).
     */
    async connectorPricingScheduleAdd(
        requestParameters: ConnectorPricingScheduleAddRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.connectorPricingScheduleAddRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get connector pricing schedules for organisation / user
     */
    async connectorPricingScheduleListRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<PricingSchedulesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/connector-pricing-schedules`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            PricingSchedulesResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get connector pricing schedules for organisation / user
     */
    async connectorPricingScheduleList(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<PricingSchedulesResponse> {
        const response =
            await this.connectorPricingScheduleListRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get active and inactive device connector pricings
     */
    async deviceConnectorPricingScheduleRaw(
        requestParameters: DeviceConnectorPricingScheduleRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ConnectorPricingScheduleListResponse>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceConnectorPricingSchedule().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["connectorIndex"] != null) {
            queryParameters["connectorIndex"] =
                requestParameters["connectorIndex"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/connector-pricing`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ConnectorPricingScheduleListResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get active and inactive device connector pricings
     */
    async deviceConnectorPricingSchedule(
        requestParameters: DeviceConnectorPricingScheduleRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ConnectorPricingScheduleListResponse> {
        const response = await this.deviceConnectorPricingScheduleRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get all devices with the connectors with pricing schedule groups by pricing schedule group id.
     */
    async getDevicesByPricingScheduleGroupIdRaw(
        requestParameters: GetDevicesByPricingScheduleGroupIdRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DevicePricingScheduleGroupDto>>> {
        if (requestParameters["pricingScheduleGroupId"] == null) {
            throw new runtime.RequiredError(
                "pricingScheduleGroupId",
                'Required parameter "pricingScheduleGroupId" was null or undefined when calling getDevicesByPricingScheduleGroupId().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/connector-pricing-schedules/{pricingScheduleGroupId}`.replace(
                    `{${"pricingScheduleGroupId"}}`,
                    encodeURIComponent(
                        String(requestParameters["pricingScheduleGroupId"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DevicePricingScheduleGroupDtoFromJSON),
        );
    }

    /**
     * Get all devices with the connectors with pricing schedule groups by pricing schedule group id.
     */
    async getDevicesByPricingScheduleGroupId(
        requestParameters: GetDevicesByPricingScheduleGroupIdRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DevicePricingScheduleGroupDto>> {
        const response = await this.getDevicesByPricingScheduleGroupIdRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get connector pricing schedules for organisation / user by the pricing schedule id.
     */
    async pricingScheduleListByPricingScheduleGroupIdRaw(
        requestParameters: PricingScheduleListByPricingScheduleGroupIdRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<PricingSchedulesResponse>> {
        if (requestParameters["pricingScheduleGroupId"] == null) {
            throw new runtime.RequiredError(
                "pricingScheduleGroupId",
                'Required parameter "pricingScheduleGroupId" was null or undefined when calling pricingScheduleListByPricingScheduleGroupId().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/connector-pricing-schedules/{pricingScheduleGroupId}`.replace(
                    `{${"pricingScheduleGroupId"}}`,
                    encodeURIComponent(
                        String(requestParameters["pricingScheduleGroupId"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            PricingSchedulesResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get connector pricing schedules for organisation / user by the pricing schedule id.
     */
    async pricingScheduleListByPricingScheduleGroupId(
        requestParameters: PricingScheduleListByPricingScheduleGroupIdRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<PricingSchedulesResponse> {
        const response =
            await this.pricingScheduleListByPricingScheduleGroupIdRaw(
                requestParameters,
                initOverrides,
            );
        return await response.value();
    }
}
